module.exports = __webpack_public_path__ + "img/dingzhilvyouxianlu.6aae2646.png";